module.exports = __webpack_public_path__ + "media/images/pic/brodno/hero-8e0755d617cef8d0e90d6f2f17d0d66a.jpg";